import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { ReactReduxContext } from 'react-redux'

import RestrictedInner from './RestrictedInner'


@withRouter
class Restricted extends Component {
  render() {
    return (
      <ReactReduxContext.Consumer>
        {({ store }) => {
          return (
            <RestrictedInner {...this.props} store={store} />
          )
        }}
      </ReactReduxContext.Consumer>
    )
  }
}

export default Restricted
